import axios from "axios";
import { SITE_SETTINGS_API } from "../../../constants/api";

export default function GetSiteSettings(){
    const api = `${SITE_SETTINGS_API}o/`;
    return axios.get(api);
}